import * as React from 'react';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';

import * as api from '../../api';

import { getOptionsFromRecord } from '../utils';
import Enum from './Enum';

interface Props {
  pronounOptions: api.Patient.Pronoun[];
  onChange: (value: string) => Promise<void>;
  useAlternateEnum: boolean;
  value: string;
}

export const PreferredPronounInput: React.FC<Props> = ({
  pronounOptions,
  onChange,
  value,
  useAlternateEnum,
}) => {
  const { t } = useTranslation();
  const displayOptions = getOptionsFromRecord(
    _.pick(api.Previsit.pronounMap, pronounOptions),
    t,
  );
  return (
    <Enum
      value={value}
      options={displayOptions}
      useAlternateEnum={useAlternateEnum}
      onChange={onChange}
    />
  );
};
